import { useContext } from "react";
import { PermissionScopeContext } from "../store/permission-scope-context";
import { ProfileRightsContext } from "../store/profile-rights-context";

// Resolves the profile id from the explicit arg or the surrounding PermissionScope,
// then asks the ProfileRightsProvider whether the current user may write it.
// Fail-open when used outside the provider (the backend is the real gate).
export default function useCanWrite(profileId?: number | null): boolean {
  const scopeId = useContext(PermissionScopeContext);
  const canWrite = useContext(ProfileRightsContext);
  return canWrite(profileId ?? scopeId);
}
